import { render, staticRenderFns } from "./cell_popover_list.vue?vue&type=template&id=b4df95de&"
import script from "./cell_popover_list.vue?vue&type=script&lang=js&"
export * from "./cell_popover_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports